import { Stack, Typography } from '@mui/joy';
import { Warning } from '@phosphor-icons/react';
import { CustomCellRendererProps } from 'ag-grid-react';

import { TextEllipsis, Tooltip } from 'core/elements';
import { Direction, Level } from 'theme/enums';

import { getManufacturerStatusWarning } from '../utils';

export const ImportedManufacturerCell = ({
  data,
  value,
  valueFormatted,
  setTooltip,
}: CustomCellRendererProps) => {
  // Group rows have no data — keep the plain (possibly empty) label, like the
  // rest of this table.
  if (!data) {
    return <>{valueFormatted}</>;
  }

  if (value) {
    // TextEllipsis is what calls setTooltip, so a clipped name is readable on
    // hover — the adjacent Partfiniti Manufacturer column gets that from the
    // default renderer, and these two columns exist to be compared.
    return <TextEllipsis content={value} setTooltip={setTooltip} />;
  }

  const warning = getManufacturerStatusWarning(data);

  // Older BE payloads carry no status: nothing to explain, so fall back to the
  // formatter's placeholder.
  if (!warning) {
    return <>{valueFormatted}</>;
  }

  return (
    <Tooltip title={warning.tooltip}>
      <Stack
        direction={Direction.ROW}
        sx={{ alignItems: 'center', color: warning.color, gap: 0.5, height: '100%' }}
      >
        <Warning />
        {/* The reason in words, not colour alone: NOT_PERSISTED and
            NO_MANUFACTURER share the danger colour, so icon-only made two
            different states pixel-identical — and nothing inside the tooltip
            wrapper is focusable, so hover was the only way to read either. The
            exporter already writes this same label. */}
        <Typography noWrap level={Level.BODY_SM} sx={{ color: 'inherit' }}>
          {warning.label}
        </Typography>
      </Stack>
    </Tooltip>
  );
};
